import React from 'react';
import { getGlobalTheme } from '@atlaskit/tokens';
import { JiraDarkTheme } from '../../assets/jira/dark-theme';
import { JiraLightTheme } from '../../assets/jira/light-theme';
import { DesktopOnlyBackground } from '../../common/ui';
export var JiraBackground = function JiraBackground(_ref) {
  var children = _ref.children;
  var isDarkMode = getGlobalTheme().colorMode === 'dark';
  var Background = isDarkMode ? JiraDarkTheme : JiraLightTheme;
  return /*#__PURE__*/React.createElement(DesktopOnlyBackground, {
    background: Background
  }, children);
};